module.exports = __webpack_public_path__ + "static/media/saka_text_04.63878c3b.jpg";